import { Request } from './Request'

export class RequestWithContent<T, D> extends Request<T> {
  public constructor(origin: Request<T>, content: D) {
    super(origin)
    this.requestMessage.data = content
  }
}
